import { render, staticRenderFns } from "./chooseList.vue?vue&type=template&id=51675e6c"
import script from "./chooseList.vue?vue&type=script&lang=js"
export * from "./chooseList.vue?vue&type=script&lang=js"
import style0 from "./chooseList.vue?vue&type=style&index=0&id=51675e6c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports